/**
 * The enum to represent slider marker position for range
 */
export enum Marker {
  /**
   * Marker start position
   */
  Start = 'start',

  /**
   * Marker end position
   */
  End = 'end',
}
